import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Guard, Permissions } from "../../role/Guard.jsx"
import EventBus from "../EventBus.js"
import GlobalHelper from "../GlobalHelper.jsx"
import { hasScreenSizeChanged } from "../Helpers"
import Icon from "../icon/icon.component.jsx"
import LinkSideBarWrapper from '../rich-text/feature-protection-wrappers/linkSideBarWrapper.component'
import { GetAllowedAdminMenus, GetAllowedMenus, GetImpersonation, GetMenuAccountStatus, GetMenuPermissions } from "./menus.jsx"
import './sidebar.scss'

let MenuState = 'closed'

class SideBar extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            user: AppContext.getUserLoggedIn(),
            showMenu: this.props.showMenu || false,
            impersonation: null,
            notification: '',
            showNotification: false,
            menuState: MenuState,
            initialScreenSize: GlobalHelper.getResponsiveBreakpoint(),
        }
        this.hideMenu = this.hideMenu.bind(this)
        this.menuInit = this.menuInit.bind(this)
        this.showNotification = this.showNotification.bind(this)
        this.onToggleMenu = this.props.onToggleMenu || function () { }
        this.permissions = GetMenuPermissions
        EventBus.listen(EventBus.TopicSendSuccessNotification, 'sidebar-component', this.showNotification)
    }

    componentDidMount() {
        const session = AppContext.getSession()
        if (session && session.attributes.impersonateAccountId) {
            AppContext.getApiClient().get('/accounts/' + session.attributes.impersonateAccountId).then(a => {
                this.setState({
                    impersonation: a
                })
            })
        }
        this.menuInit()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (hasScreenSizeChanged(this.state.initialScreenSize)) {
            if (this.state.initialScreenSize === "xl" || GlobalHelper.getResponsiveBreakpoint() === "xl") {
                this.menuInit()
                this.setState({
                    showMenu: true,
                    initialScreenSize: GlobalHelper.getResponsiveBreakpoint()
                })
            }
        }
    }

    showNotification(event) {
        this.setState({
            notification: event.getData().message,
            showNotification: true,
        }, () => {
            $('#successNotification').addClass('show')
            setTimeout(() => {
                $('#successNotification').removeClass('show')
                this.setState({ showNotification: false })
            }, 3000)
        })

    }

    menuInit() {
        const sidebarPadding = $(".sidebar").outerWidth(true) - $(".sidebar").width()
        const maxWidth = $(".sidebar ul.nav").width() + sidebarPadding + (sidebarPadding / 4)
        if (["xl"].includes(GlobalHelper.getResponsiveBreakpoint())) {
            let that = this
            $(".menu-text").css('display', 'none')
            $(".sidebar").mouseenter(function () {
                if (['opening', 'closing', 'open'].includes(MenuState)) {
                    return
                }
                MenuState = 'opening'
                $(".menu-text").css('display', 'none')
                $(".sidebar").animate({
                    width: maxWidth,
                }, 205, function () {
                    $(".menu-text").css('display', 'inline-block')
                    MenuState = 'open'
                    that.setState({
                        menuState: MenuState,

                    })
                    $(".sidebar").removeClass("closed")
                });
            });

            $(".sidebar").mouseleave(function () {
                if (['opening', 'closing', 'closed'].includes(MenuState)) {
                    return
                }
                MenuState = 'closing'
                that.setState({
                    menuState: 'closed',
                })
                $(".menu-text").css('display', 'none')
                $(".sidebar").animate({
                    width: 65,
                }, 205, function () {
                    MenuState = 'closed'
                    $(".menu-text").css('display', 'none')
                    $(".sidebar").addClass("closed")
                });
            });
            $("#react-container").mousemove(function (event) {
                if ($('.sidebar:hover').length === 0 && MenuState === 'open') {
                    MenuState = 'closing'
                    that.setState({
                        menuState: 'closed',

                    })
                    $(".menu-text").css('display', 'none')
                    $(".sidebar").animate({
                        width: 65,
                    }, 205, function () {
                        MenuState = 'closed'
                        $(".menu-text").css('display', 'none')
                        $(".sidebar").addClass("closed")
                    });
                }
            });
        } else {
            $(".menu-text").css('display', 'inline-block')
            $(".sidebar").css('width', 'auto')
            $(".sidebar").removeClass("closed")
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            showMenu: nextProps.showMenu || false,
        })
    }

    hideMenu(event) {
        if (this.state.showMenu) {
            this.onToggleMenu()
        }
    }

    render() {
        let adminMenuItems = []
        if (Guard.isAuthorized(Permissions.AdminMenus)) {
            adminMenuItems = GetAllowedAdminMenus()
        }

        const commonContainerClasses = "px-3 pt-2 box-shadow sidebar bg-sidebar position-fixed full-height z-index-menu"

        let containerClasses = commonContainerClasses + " d-none d-xl-block"
        if (this.state.showMenu) {
            containerClasses = commonContainerClasses + " "
        }
        let status = GetMenuAccountStatus()
        let impersonation = GetImpersonation(this.state.impersonation)
        const name = AppContext.getUserLoggedIn().attributes.firstName + ' ' +
            AppContext.getUserLoggedIn().attributes.lastName.charAt(0).toUpperCase() + '.'
        let menus = GetAllowedMenus()
        
        const content = [
            <nav key={0} className={containerClasses} style={{ width: '65px' }}>
                <div className="sidebar-sticky d-flex align-content-between flex-wrap " style={{ height: '90%' }}>
                    <ul className="nav flex-column">
                        {
                            (this.state.menuState === 'open' || this.state.showMenu) && (!(["xl"].includes(GlobalHelper.getResponsiveBreakpoint()))) &&
                            [status]
                        }
                        {impersonation}
                        <li className="nav-item d-block d-md-none p-2 border-bottom mb-2">
                            <div className="text-dark user-logged-in text-left">
                                <Icon value="user-circle" />
                                <span className="d-xl-inline-block">
                                    {name}
                                </span>
                                &nbsp;
                                <span>
                                    <a href={
                                        AppContext.getOptions().apiUrl + "/logout?r=" +
                                        AppContext.getOptions().webCpqUrl + "/logout"
                                    }>
                                        <Icon value="sign-out-alt" />
                                    </a>
                                </span>
                            </div>
                        </li>
                        {
                            menus.map((m, i) => {
                                return <li className="nav-item" key={i}>
                                    <LinkSideBarWrapper
                                        module={m.module}
                                        onClick={(e) => this.hideMenu(e)}
                                        to={m.link}
                                        redirectToAccount={true}
                                        className={"menu nav-link active pr-0 pl-2 d-flex flex-nowrap " + m.className}
                                        protectedClassName={"menu nav-link active pr-0 pl-2 d-flex flex-nowrap" + m.className}
                                        premium={false}
                                        protectionRule={m.module === "" ? true : AppContext.accountFeatureIsEnabled(m.module)}
                                    >
                                        {m.icon}
                                        <span className={'menu-text mr-auto'}>{m.name}</span>
                                    </LinkSideBarWrapper>
                                </li>
                            })
                        }
                        {
                            GlobalHelper.hasLightspeedIntegration() ? <li className="nav-item" style={{ height: '2.5rem', paddingLeft: '0.1rem' }}>
                                <a href={'https://us.merchantos.com/home'} className={"menu nav-link active pr-0 pl-2 d-flex flex-nowrap"} onClick={this.hideMenu}>
                                    <div className={'d-flex align-items-end'}>
                                        <div className={'mr-1'}>
                                            <img src={'/images/lightspeed_flame_logo.png'} style={{ width: '1.15rem' }} />
                                        </div>
                                        <span className={'menu-text'}>
                                            Lightspeed
                                        </span>
                                    </div>
                                </a>
                            </li> : ''
                        }
                        <li className="nav-item" key='menu-1'>
                            <hr className="menu-separator box-shadow" />
                        </li>
                        {
                            adminMenuItems.map((m, i) => {
                                const onlyForIntegrations = m.onlyForIntegrations || []
                                if (onlyForIntegrations.length > 0 && !GlobalHelper.hasIntegrations(onlyForIntegrations)) {
                                    return <></>
                                }
                                return <li className="nav-item" key={i}>
                                    <LinkSideBarWrapper
                                        module={m.module}
                                        onClick={(e) => this.hideMenu(e)}
                                        to={m.link}
                                        redirectToAccount={true}
                                        className={"menu nav-link active pr-0 pl-2 d-flex flex-nowrap " + m.className}
                                        protectedClassName={"menu nav-link active pr-0 pl-2 d-flex flex-nowrap " + m.className}
                                        premium={false}
                                        protectionRule={m.module === "" ? true : AppContext.accountFeatureIsEnabled(m.module)}
                                        isProtectedOverride={m.isProtectedOverride}
                                    >
                                        {m.icon}
                                        <span className={'menu-text mr-auto'}>{m.name}</span>
                                    </LinkSideBarWrapper>
                                </li>
                            })
                        }
                        {
                            AppContext.getAccount().isFeatureEnabled(Features.Automation) &&
                                <li className="nav-item" key='menu-13'>
                                    <Link to="/workflows/listing" className="menu menu-automation nav-link pr-0 pl-2 d-flex flex-nowrap " onClick={this.hideMenu}>
                                        <Icon value="robot" className={"mr-1"} />
                                        <span className={'menu-text'}>
                                            <FormattedMessage
                                                id="main.menu.automation"
                                                defaultMessage="Automation"
                                            />
                                        </span>
                                    </Link>
                                </li>
                        }
                        <li className="nav-item pt-3" style={{ height: '3rem', paddingLeft: '0.1rem' }}>
                            <Link to={'/quotes/new'} className={"menu active nav-link pr-1 pl-1 pt-1 pb-0 btn btn-primary text-white btn-rounded menu-new-quote-btn"} onClick={this.hideMenu}>
                                <Icon value="plus" className={'text-white pr-1'} />
                                <span className={'menu-text text-white'}>
                                    <FormattedMessage
                                        id="main.menu.new_quote"
                                        defaultMessage="New proposal"
                                    />
                                </span>
                            </Link>
                        </li>

                    </ul>
                </div>
            </nav>,
        ]
        if (this.state.showNotification) {
            content.push(<div key={1} id={'successNotification'} className="alert alert-success alert-dismissible fade fixed-bottom ml-3" role="alert" style={{
                zIndex: 9900,
                width: '400px',
            }}>
                {this.state.notification}
            </div>)
        }
        return content
    }

    static activateMenu(menu) {
        $('.menu').removeClass('active')
        $('.menu-' + menu).addClass('active')
    }
}

export default SideBar


// WEBPACK FOOTER //
// ./src/common/layout/sidebar.component.jsx